import { createColumnHelper } from '@tanstack/react-table'

import React, { useMemo } from 'react'

import { usePreferences } from 'context/preferences/PreferencesContext'
import { createTableColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { DoorProxyForDealsSelection } from 'models/door_proxies_for_deals_selection'
import { AFbLink } from 'components/FbUI/FbLink/styles'
import { SELECT_LOCATIONS } from './selectLocationsForDealColumnInfo'

export function useSelectLocationsForDealTableColumn() {
  const { preferences } = usePreferences()
  const tooltips: Record<string, unknown> = preferences?.tooltips || {}
  const columnHelper = createColumnHelper<DoorProxyForDealsSelection>()
  const doorProxyForDealSelColumnHelper = createTableColumnHelper({
    columns: SELECT_LOCATIONS,
    tooltips,
  })
  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        ...doorProxyForDealSelColumnHelper.retrieveColumn('name'),
        header: '',
      }),
      columnHelper.accessor('address', {
        ...doorProxyForDealSelColumnHelper.retrieveColumn('address'),
      }),
      columnHelper.accessor('city', {
        ...doorProxyForDealSelColumnHelper.retrieveColumn('city'),
        size: 150,
      }),
      columnHelper.accessor('state', {
        ...doorProxyForDealSelColumnHelper.retrieveColumn('state'),
        size: 100,
      }),
      columnHelper.accessor('zipcode', {
        ...doorProxyForDealSelColumnHelper.retrieveColumn('zipcode'),
        size: 100,
      }),
      columnHelper.accessor('dma', {
        ...doorProxyForDealSelColumnHelper.retrieveColumn('dma'),
        size: 200,
      }),
      columnHelper.accessor('domain', {
        ...doorProxyForDealSelColumnHelper.retrieveColumn('domain'),
        cell: (info) => {
          const domain = info.getValue()
          return (
            <AFbLink
              href={`https://${domain}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {domain}
            </AFbLink>
          )
        },
        size: 200,
      }),
      columnHelper.accessor('place_url', {
        ...doorProxyForDealSelColumnHelper.retrieveColumn('place_url'),
        cell: (info) => {
          const placeUrl = info.getValue()
          return (
            <AFbLink href={placeUrl} target="_blank" rel="noopener noreferrer">
              View Place
            </AFbLink>
          )
        },
      }),
    ],
    [tooltips]
  )
  return columns
}
